var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aeg-case-home',{attrs:{"caseViews":_vm.caseViews,"addProposalButtonText":"Add Commercial Block Proposal","productTypeLabel":"Type","selectProductInsuranceType":"commercial_block"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }